// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-AutoDocExtraction-SparkleMessage-SparkleMessage-module__sparkleContainer";
var _2 = "webpack-concepts-AutoDocExtraction-SparkleMessage-SparkleMessage-module__text";
export { _1 as "sparkleContainer", _2 as "text" }
